import {createContext, useState, useContext, useMemo, useCallback} from 'react';
import { childrenProps } from '../Components/common/types';

type Theme = 'light' | 'dark';

interface ThemeContextProps {
    theme: Theme;
    toggleTheme: () => void;
}

const ThemeContext = createContext<ThemeContextProps | undefined>(undefined);

export const useTheme = () => {
    const context = useContext(ThemeContext);

    if(!context) {
        throw new Error('useTheme must be within a ThemeProvider');
    }
    return context;
}

export function ThemeProvider({children}: childrenProps) {
    const [theme, setTheme] = useState<Theme>(() => {
        const savedTheme = localStorage.getItem('theme') as Theme | null;
        return savedTheme ?? 'light';
    });

    // const toggleTheme = () => {
    //     const updatedTheme = theme === 'light' ? 'dark' : 'light';
    //     setTheme(updatedTheme);
    //     localStorage.setItem('theme', updatedTheme);
    // }

    const toggleTheme = useCallback(() => {
        setTheme(prevTheme => {
          const updatedTheme = prevTheme === 'light' ? 'dark' : 'light';
          localStorage.setItem('theme', updatedTheme);
          return updatedTheme;
        });
      }, []);

    const value = useMemo(() => ({ theme, toggleTheme }), [theme, toggleTheme]);

    return (
        // { theme, toggleTheme })
        <ThemeContext.Provider value={value}> 
            {children}
        </ThemeContext.Provider>
    )
}